import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7n3gewfjp: FaireProductEntity = {
  token: "p_t7n3gewfjp",
  type: "product",
  name: "LE GRAND MULHOLLAND",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/5ea6dc566974b6c8f25ccc490f94a3487ab9febddb30ae05c767ff13ec8b1c94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa02a15d3f6327b81f29351f07c5c54256a65fd8c9504b1864d43537c37df49c.jpeg",
    "https://cdn.faire.com/fastly/64ace5375b196f4ed31f652b99c335a603476ac02058ae4fd5aa2680e269e035.jpeg"
  ],
  priceDollars: 30,
  description: "Meet our new Le Grand Mulholland, 14 oz of your favorite scent is finally here!\n\nA rich but sophisticated fragrance that intertwines the alluring scent of hinoki wood with creamy notes of amber resin and suede. Nuances of clove bud, incense and spice unfurl to give this opulent scent a layer of warmth and complexity.\n\nhinoki wood, amber resin, suede, incense, clove bud\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:10.344Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
